import { cva } from "class-variance-authority";

/**
 * Shared card styling variants used across BentoGrid and CardGrid components
 * Provides consistent background and border-radius
 * Note: Border is applied separately via HairlineCardBorder component
 */
export const bentoCardVariants = cva("tw-rounded-2.5xl tw-relative tw-overflow-hidden", {
  variants: {
    background: {
      default: "tw-bg-cream",
      none: "",
    },
    size: {
      default: "",
      large: "",
    },
  },
  defaultVariants: {
    background: "default",
    size: "default",
  },
});
